import { render, staticRenderFns } from "./bindingAccount.vue?vue&type=template&id=955f53fa&scoped=true&"
import script from "./bindingAccount.vue?vue&type=script&lang=js&"
export * from "./bindingAccount.vue?vue&type=script&lang=js&"
import style0 from "./bindingAccount.vue?vue&type=style&index=0&id=955f53fa&prod&scoped=true&lang=scss&"
import style1 from "./bindingAccount.vue?vue&type=style&index=1&id=955f53fa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "955f53fa",
  null
  
)

export default component.exports